import GridTable from "../../components/GridTable";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formatDateToDDMMYYYY } from "../../uitls/Utils";
import { filterUsersByDept_and_Role } from "../../api/userApi";
import { ROLE_OPTIONS } from "../../uitls/Contant";
import useAuth from "../../hooks/useAuth";
import Loader from "../../components/Loader";
import { Tooltip } from "@mui/material";
import { CheckCircle, Cancel } from "@mui/icons-material";

const ManagerEmployee = () => {
  const dispatch = useDispatch();
  const { auth } = useAuth();
  const { usersByDept_and_role, loading } = useSelector(
    (state) => state.userState
  );
  const managerId = auth?.user?.id;
  useEffect(() => {
    if (managerId) {
      dispatch(
        filterUsersByDept_and_Role({
          managerId: managerId,
        })
      );
    }
  }, [dispatch, managerId]);

  const allColumns = [
    {
      field: "name",
      headerName: "Name",
      width: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <span>
          {params.row?.firstName} {params.row?.lastName}
        </span>
      ),
    },
    {
      field: "corporateEmail",
      headerName: "Organizational Email",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "role",
      headerName: "Role",
      width: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <span>
          {ROLE_OPTIONS.find(
            (role) => role.value === params.row.userRoleId
          )?.label?.toUpperCase()}
        </span>
      ),
    },
    {
      field: "mfaStatus",
      headerName: "MFA Status",
      width: 180,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const isMfaEnabled = params.row.mfaEnabled === true;
        return (
          <div className="flex items-center gap-2">
            {isMfaEnabled ? (
              <Tooltip title="MFA Verified">
                <div className="flex items-center gap-1 text-green-600">
                  <CheckCircle style={{ fontSize: "18px" }} />
                  <span className="text-sm font-medium">Verified</span>
                </div>
              </Tooltip>
            ) : (
              <Tooltip title="MFA Not Verified">
                <div className="flex items-center gap-1 text-orange-600">
                  <Cancel style={{ fontSize: "18px" }} />
                  <span className="text-sm font-medium">Not Verified</span>
                </div>
              </Tooltip>
            )}
          </div>
        );
      },
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      width: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => <span>{formatDateToDDMMYYYY(params.value)}</span>,
    },
    {
      field: "updatedDate",
      headerName: "Updated Date",
      width: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => <span>{formatDateToDDMMYYYY(params.value)}</span>,
    },
  ];

  const superManagerColumns = [
    {
      field: "name",
      headerName: "Name",
      width: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <span>
          {params.row?.firstName} {params.row?.lastName}
        </span>
      ),
    },
    {
      field: "corporateEmail",
      headerName: "Organizational Email",
      width: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "role",
      headerName: "Role",
      width: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <span>
          {ROLE_OPTIONS.find(
            (role) => role.value === params.row.userRoleId
          )?.label?.toUpperCase()}
        </span>
      ),
    },
    {
      field: "manager",
      headerName: "Manager",
      width: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => <span>{params?.value?.name}</span>,
    },
    {
      field: "mfaStatus",
      headerName: "MFA Status",
      width: 180,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const isMfaEnabled = params.row.mfaEnabled === true;
        return (
          <div className="flex items-center gap-2">
            {isMfaEnabled ? (
              <Tooltip title="MFA Verified">
                <div className="flex items-center gap-1 text-green-600">
                  <CheckCircle style={{ fontSize: "18px" }} />
                  <span className="text-sm font-medium">Verified</span>
                </div>
              </Tooltip>
            ) : (
              <Tooltip title="MFA Not Verified">
                <div className="flex items-center gap-1 text-orange-600">
                  <Cancel style={{ fontSize: "18px" }} />
                  <span className="text-sm font-medium">Not Verified</span>
                </div>
              </Tooltip>
            )}
          </div>
        );
      },
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      width: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => <span>{formatDateToDDMMYYYY(params.value)}</span>,
    },
    {
      field: "updatedDate",
      headerName: "Updated Date",
      width: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => <span>{formatDateToDDMMYYYY(params.value)}</span>,
    },
  ];

  const columns = auth?.user.managerId ? allColumns : superManagerColumns; //allColumns.filter((column) => column.field == 'managerName'&& !auth?.user.managerId )

  // Ensure data is an array for GridTable
  const rowData = Array.isArray(usersByDept_and_role)
    ? usersByDept_and_role
    : [];

  return (
    <div className="pt-4 md:pt-6 2xl:pt-10 w-full px-4 md:px-6 lg:px-8">
      {loading && <Loader />}
      <GridTable rowData={rowData} columnData={columns} />
    </div>
  );
};

export default ManagerEmployee;
